import React from 'react'
import PropTypes from 'prop-types'
import SearchBar from '../../../../../../components/search/SearchBar'

const DoxExplorerTitleSearchBar = (props) => {
    return (
        <div className='doxe-search hrb-column hrb-is-10'>
            <SearchBar elementId='doxe-search' placeholderKey='Dox.DocumentExplorer.Search' maxLength={100}
                performSearch={props.onSearch} defaultValue='' showButton allowEmptySearch />
        </div>
    )
}

DoxExplorerTitleSearchBar.propTypes = {
    onSearch: PropTypes.func.isRequired
}

export default DoxExplorerTitleSearchBar;